import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WelcomeReducer } from '.';

export const featureSelector = createFeatureSelector<WelcomeReducer.State>('welcome');

export const isVisible = createSelector(
  featureSelector,
  state => state.visible
);


export const loadingDashboards = createSelector(
  featureSelector,
  state => state.loadingDashboards
);

export const dashboards = createSelector(
  featureSelector,
  state => state.dashboards
);

export const displayedDashboards = createSelector(
  featureSelector,
  state => state.displayedDashboards
);


export const selectedDashboardId = createSelector(
  featureSelector,
  state => state.selectedDashboardId
);

